export const GOODS_DESCRIPTION_CATALOG = [
  { id: 1, name: "Fabric" },
  { id: 2, name: "Accessories" },
  { id: 3, name: "Fabric & Accessories" },
  { id: 4, name: "Print" },
  { id: 5, name: "Washing" },
  { id: 6, name: "Embroidery" },
  { id: 7, name: "Testing" },
  { id: 8, name: "Inspection" },
  { id: 9, name: "Courier" },
  { id: 10, name: "Portal" },
];

const nameById = new Map(
  GOODS_DESCRIPTION_CATALOG.map((item) => [item.id, item.name]),
);

/**
 * Resolve API goods_description (e.g. "[[1],[1]]", array, id, or plain name) for display.
 */
export function formatGoodsDescriptionDisplay(raw) {
  if (raw === undefined || raw === null || raw === "") return "";

  let parsed = raw;
  if (typeof raw === "string") {
    const s = raw.trim();
    if (!s) return "";
    try {
      parsed = JSON.parse(s);
    } catch {
      const id = Number(s);
      if (!Number.isNaN(id) && nameById.has(id)) return nameById.get(id);
      return s;
    }
  }

  if (Array.isArray(parsed)) {
    const names = [
      ...new Set(
        parsed
          .flat(Infinity)
          .map((x) => nameById.get(Number(x)))
          .filter(Boolean),
      ),
    ];
    return names.join(", ");
  }

  const id = Number(parsed);
  if (!Number.isNaN(id) && nameById.has(id)) return nameById.get(id);
  if (typeof parsed === "string" && parsed) return parsed;
  return String(raw);
}
